import type { LazyCreateFormConfig } from '@workwave-tidal/form-fairy'
import type { ValidationSummaryItem } from '@workwave-tidal/form-ui/utils/ValidationSummary'
import type { FormErrors, FormFields } from '../../../formFields'

import { useState } from 'react'
import { useSelector } from 'react-redux'

import { selectGpsUser } from '@/features/domain/user'
import { useStandardPasswordValidations } from '@/hooks'

export function useCreateFormConfig(): {
  createFormConfig: LazyCreateFormConfig<FormFields, FormErrors>
  validationSummaryItems: ValidationSummaryItem<FormFields>[]
} {
  // the password being changed belongs to the GPS user, whose login id is `loginName`
  const username = useSelector(selectGpsUser)?.loginName

  // New Password validations
  const { validations, validationSummaryItems } = useStandardPasswordValidations<
    FormFields,
    FormErrors
  >('newPassword', { username })

  const [createFormConfig] = useState<LazyCreateFormConfig<FormFields, FormErrors>>(() => {
    return { validations }
  })

  return { createFormConfig, validationSummaryItems }
}
